module.exports = __webpack_public_path__ + "img/powerball_bg.08a73714.png";